import qs from 'querystring'
import _ from 'lodash';
import moment from 'moment';
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'
import dateFormat from '../../../../../util/dateFormat'

//constant
const API_PREFIX = '/icenter'

const DEFAULT_SIZE = 10

const LIST_API = `${API_PREFIX}/list`

const RECEIVE_BILL_LIST = `RECEIVE_BILL_LIST`

export const CHANGE_PAGE = `ICENTER_CHANGE_PAGE`

export const CHANGE_MESSAGE = `ICENTER_CHANGE_MESSAGE`

export const CHANGE_SQUERY = `ICENTER_CHANGE_SQUERY`

export const CHANGE_TQUERY = `ICENTER_CHANGE_TQUERY`

export const S_RECEIVE_LIST = `ICENTER_S_RECEIVE_LIST`;

export const T_RECEIVE_LIST = `ICENTER_T_RECEIVE_LIST`;



//action
function getBillData(params,dispatch) {
    return http.get(`${LIST_API}?${qs.stringify(params)}`)
        .then(data => {
            dispatch({
                type: RECEIVE_BILL_LIST,
                data: data.data
            })
        })
}
export function getBillList() {
    return (dispatch,getState) => {
        const {icenter:{page}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        return getBillData(data,dispatch)
    }
}

export function updateUser(roleId) {
    return (dispatch,getState) => {
        const {icenter: {changeMessage: {name,phone}}} = getState()
        const formData = { }
        if (name) {
            formData['name'] = name
        }
        if (phone) {
            formData['phone'] = phone
        }
        return http.post(`/account/update/${roleId}`,formData)
    }
}

export function getSList() {
    return (dispatch,getState) => {
        const {icenter: {squery}} = getState()
        const params = {
            page: 0,
            size: 10000
        }
        const form = {
            "logic": "and",
            "filters": []
        }
        
        form.filters.push({
            "field": 'createTime',
            "operator": 'gte',
            "value": `${squery.start_time} 00:00:00`
        })
        form.filters.push({
            "field": 'createTime',
            "operator": 'lte',
            "value": `${squery.end_time} 00:00:00`
        })
        const userInfo = http.getUserInfo();
        console.info(userInfo);
        let form1;
        let params1 = {...params, start_time: squery.start_time, end_time: squery.end_time};
        if (!(http.isRoot() || http.isJuan())) { // 售前
            form.filters.push({
                "logic": "or",
                "filters": [
                    {"field": "accountId", "operator": "eq", "value": userInfo.user.id}
                ]
            });
            form1 = _.cloneDeep(form);
            params1 = {...params1, account_id: userInfo.user.id}
        } else {
            form1 = _.cloneDeep(form);
            // form1.filters.push({
            //     "logic": "or",
            //     "filters": [
            //         {"field": "paymentMethod", "operator": "eq", "value": '线上淘宝'}
            //     ]
            // })
        }
        return Promise.all([
            http.post(`/order-sd/list?${qs.stringify(params)}`, form),
            http.post(`/order-jzhz/list?${qs.stringify(params)}`, form),
            http.post(`/order-domain/list?${qs.stringify(params)}`, form),
            http.post(`/order-copy/list?${qs.stringify(params)}`, form1),
            http.post(`/order-my/list?${qs.stringify(params)}`, form1),
            http.post(`/order-renew/list?${qs.stringify(params)}`, form),
            http.post(`/order-copy/list-refund?${qs.stringify(params1)}`, form1),
            http.post(`/order-my/list-refund?${qs.stringify(params1)}`, form1),
        ])
            .then(([sdData, jzhzData, domainData, copyData, myData, renewData, copyRefundData, myRefundData]) => {
                const unpainFn = item => ['待付款'].includes(item.status);
                const refundFn = item => ['退款中', '退款审核', '退款完成'].includes(item.status);
                const painFn = item => !['待付款'].includes(item.status);
                const renewFn = item => ['续费'].includes(item.status);
                const sdGroup = _.groupBy(sdData.data.list, 'accountName');
                const jzhzGroup = _.groupBy(jzhzData.data.list, 'accountName');
                const domainGroup = _.groupBy(domainData.data.list, 'accountName');
                const copyGroup = _.groupBy(copyData.data.list, 'accountName');
                const myGroup = _.groupBy(myData.data.list, 'accountName');
                // const renewGroup = _.groupBy(renewData.data.list, 'accountName');
                const copyRefundGroup = _.groupBy(copyRefundData.data.list, 'accountName');
                const myRefundGroup = _.groupBy(myRefundData.data.list, 'accountName');
                dispatch({
                    type: S_RECEIVE_LIST,
                    data: {
                        _sdData: sdData.data.list,
                        _jzhzData: jzhzData.data.list,
                        _domainData: domainData.data.list,
                        _copyData: copyData.data.list,
                        _myData: myData.data.list,
                        _renewData: renewData.data.list,
                        sdData: {
                            list: Object.keys(sdGroup).map(key => {
                                return {
                                    name: key,
                                    pain: _.sumBy(sdGroup[key].filter(painFn), 'orderMoney') + _.sumBy(sdGroup[key].filter(painFn), 'decorationMoney'),
                                    unpain: _.sumBy(sdGroup[key].filter(unpainFn), 'orderMoney'),
                                    refund: _.sumBy(sdGroup[key].filter(refundFn), 'orderMoney'),
                                    renew: _.sumBy(sdGroup[key].filter(renewFn), 'orderMoney')
                                }
                            }),
                            total: {
                                pain: _.sumBy(sdData.data.list.filter(painFn), 'orderMoney') + _.sumBy(sdData.data.list.filter(painFn), 'decorationMoney'),
                                unpain: _.sumBy(sdData.data.list.filter(unpainFn), 'orderMoney'),
                                refund: _.sumBy(sdData.data.list.filter(refundFn), 'orderMoney'),
                                renew: _.sumBy(sdData.data.list.filter(renewFn), 'orderMoney')
                            }
                        },
                        jzhzData: {
                            list: Object.keys(jzhzGroup).map(key => {
                                return {
                                    name: key,
                                    pain: _.sumBy(jzhzGroup[key].filter(painFn), 'orderMoney') + _.sumBy(jzhzGroup[key].filter(painFn), 'decorationMoney'),
                                    unpain: _.sumBy(jzhzGroup[key].filter(unpainFn), 'orderMoney'),
                                    refund: _.sumBy(jzhzGroup[key].filter(refundFn), 'orderMoney'),
                                    renew: _.sumBy(jzhzGroup[key].filter(renewFn), 'orderMoney')
                                }
                            }),
                            total: {
                                pain: _.sumBy(jzhzData.data.list.filter(painFn), 'orderMoney') + _.sumBy(jzhzData.data.list.filter(painFn), 'decorationMoney'),
                                unpain: _.sumBy(jzhzData.data.list.filter(unpainFn), 'orderMoney'),
                                refund: _.sumBy(jzhzData.data.list.filter(refundFn), 'orderMoney'),
                                renew: _.sumBy(jzhzData.data.list.filter(renewFn), 'orderMoney')
                            }
                        },
                        domainData: {
                            list: Object.keys(domainGroup).map(key => {
                                return {
                                    name: key,
                                    pain: _.sumBy(domainGroup[key].filter(painFn), 'domainMoney'),
                                    unpain: _.sumBy(domainGroup[key].filter(unpainFn), 'domainMoney'),
                                    refund: _.sumBy(domainGroup[key].filter(refundFn), 'domainMoney')
                                }
                            }),
                            total: {
                                pain: _.sumBy(domainData.data.list.filter(painFn), 'domainMoney'),
                                unpain: _.sumBy(domainData.data.list.filter(unpainFn), 'domainMoney'),
                                refund: _.sumBy(domainData.data.list.filter(refundFn), 'domainMoney')
                            }
                        },
                        copyData: {
                            list: Object.keys(copyGroup).map(key => {
                                return {
                                    name: key,
                                    pain: _.sumBy(copyGroup[key].filter(painFn), 'orderMoney'),
                                    unpain: _.sumBy(copyGroup[key].filter(unpainFn), 'orderMoney'),
                                    month_refund: _.sumBy(copyGroup[key].filter(refundFn), 'orderMoney'),
                                    refund: _.sumBy(copyRefundGroup[key], 'orderMoney'),
                                    renew: _.sumBy(copyGroup[key].filter(renewFn), 'orderMoney'),
                                    size: copyGroup[key].filter(item => item.customerAdminName).length,
                                    copy_size: copyGroup[key].filter(item => item.customerAdminName && (item.copyProject || '').trim()).length,
                                    refund_arr: (copyRefundGroup[key] || []),
                                }
                            }),
                            total: {
                                pain: _.sumBy(copyData.data.list.filter(painFn), 'orderMoney'),
                                unpain: _.sumBy(copyData.data.list.filter(unpainFn), 'orderMoney'),
                                month_refund: _.sumBy(copyData.data.list.filter(refundFn), 'orderMoney'),
                                refund: _.sumBy(copyRefundData.data.list, 'orderMoney'),
                                renew: _.sumBy(copyData.data.list.filter(renewFn), 'orderMoney'),
                                size: copyData.data.list.filter(item => item.customerAdminName).length,
                                copy_size: copyData.data.list.filter(item => item.customerAdminName && (item.copyProject || '').trim()).length,
                            }
                        },
                        myData: {
                            list: Object.keys(myGroup).map(key => {
                                return {
                                    name: key,
                                    pain: _.sumBy(myGroup[key].filter(painFn), 'orderMoney'),
                                    unpain: _.sumBy(myGroup[key].filter(unpainFn), 'orderMoney'),
                                    month_refund: _.sumBy(myGroup[key].filter(refundFn), 'orderMoney'),
                                    refund: _.sumBy(myRefundGroup[key], 'orderMoney'),
                                    renew: _.sumBy(myGroup[key].filter(renewFn), 'orderMoney'),
                                    size: myGroup[key].filter(item => item.customerAdminName).length,
                                    refund_arr: (myRefundGroup[key] || []),
                                }
                            }),
                            total: {
                                pain: _.sumBy(myData.data.list.filter(painFn), 'orderMoney'),
                                unpain: _.sumBy(myData.data.list.filter(unpainFn), 'orderMoney'),
                                month_refund: _.sumBy(myRefundData.data.list.filter(refundFn), 'orderMoney'),
                                refund: _.sumBy(myRefundData.data.list, 'orderMoney'),
                                renew: _.sumBy(myData.data.list.filter(renewFn), 'orderMoney'),
                                size: myData.data.list.filter(item => item.customerAdminName).length,
                            }
                        }
                    }
                })
            })
    };
}

export function getTList() {
    return (dispatch,getState) => {
        const {icenter: {tquery}} = getState()
        const params = {
            page: 0,
            size: 10000
        }
        const form = {
            "logic": "and",
            "filters": []
        }
        
        form.filters.push({
            "field": 'createTime',
            "operator": 'gte',
            "value": `${tquery.start_time} 00:00:00`
        })
        form.filters.push({
            "field": 'createTime',
            "operator": 'lte',
            "value": `${tquery.end_time} 00:00:00`
        })
        const userInfo = http.getUserInfo();
        console.info(userInfo);
        let form1;
        let params1 = {...params, start_time: tquery.start_time, end_time: tquery.end_time};
        if (!(http.isRoot() || http.isJuan())) { // 技术
            form.filters.push({
                "logic": "or",
                "filters": [
                    {"field": "currentAccountId", "operator": "eq", "value": userInfo.user.id},
                    {"field": "afterSalerId", "operator": "eq", "value": userInfo.user.id},
                ]
            });
            form1 = _.cloneDeep(form);
            params1 = {...params1, current_account_id: userInfo.user.id, after_saler_id: userInfo.user.id}
        } else {
            form1 = _.cloneDeep(form);
        }
        return Promise.all([
            http.post(`/order-copy/list?${qs.stringify(params)}`, form1),
            http.post(`/order-my/list?${qs.stringify(params)}`, form1),
            http.post(`/order-copy/list-techRefund?${qs.stringify(params1)}`, form1),
            http.post(`/order-my/list-techRefund?${qs.stringify(params1)}`, form1),
        ])
            .then(([copyData, myData, copyRefundData, myRefundData]) => {
                const devFilter = (item) => {
                    if (http.isRoot() || http.isJuan()) {
                        return true;
                    }
                    return item.currentAccountId === userInfo.user.id
                }
                const afterFilter = (item) => {
                    if (http.isRoot() || http.isJuan()) {
                        return true;
                    }
                    return item.afterSalerId === userInfo.user.id
                }
                const devCopyGroup = _.groupBy(copyData.data.list.filter(devFilter), 'currentAccountName');
                const devMyGroup = _.groupBy(myData.data.list.filter(devFilter), 'currentAccountName');
                const afterCopyGroup = _.groupBy(copyData.data.list.filter(afterFilter), 'afterSalerName');
                const afterMyGroup = _.groupBy(myData.data.list.filter(afterFilter), 'afterSalerName');

                const devCopyRefundGroup = _.groupBy(copyRefundData.data.list.filter(devFilter), 'currentAccountName');
                const devMyRefundGroup = _.groupBy(myRefundData.data.list.filter(devFilter), 'currentAccountName');
                const afterCopyRefundGroup = _.groupBy(copyRefundData.data.list.filter(afterFilter), 'afterSalerName');
                const afterMyRefundGroup = _.groupBy(myRefundData.data.list.filter(afterFilter), 'afterSalerName');
                dispatch({
                    type: T_RECEIVE_LIST,
                    data: {
                        devData: {
                            copyData: {
                                list: Object.keys(devCopyGroup).map(key => {
                                    return {
                                        name: key,
                                        size: devCopyGroup[key].length,
                                        sum: _.sumBy(devCopyGroup[key], 'orderMoney'),
                                        refund_size: (devCopyRefundGroup[key] || []).length,
                                        refund_sum: _.sumBy(devCopyRefundGroup[key], 'refundMoney'),
                                        refundArr: (devCopyRefundGroup[key] || []),
                                    }
                                }),
                            },
                            myData: {
                                list: Object.keys(devMyGroup).map(key => {
                                    return {
                                        name: key,
                                        size: devMyGroup[key].length,
                                        sum: _.sumBy(devMyGroup[key], 'orderMoney'),
                                        refund_size: (devMyRefundGroup[key] || []).length,
                                        refund_sum: _.sumBy(devMyRefundGroup[key], 'refundMoney'),
                                        refundArr: (devMyRefundGroup[key] || []),
                                    }
                                }),
                            },
                        },
                        afterData: {
                            copyData: {
                                list: Object.keys(afterCopyGroup).map(key => {
                                    return {
                                        name: key,
                                        size: afterCopyGroup[key].length,
                                        sum: _.sumBy(afterCopyGroup[key], 'orderMoney'),
                                        refund_size: (afterCopyRefundGroup[key] || []).length,
                                        refund_sum: _.sumBy(afterCopyRefundGroup[key], 'refundMoney'),
                                        refundArr: (afterCopyRefundGroup[key] || []),
                                    }
                                }),
                            },
                            myData: {
                                list: Object.keys(afterMyGroup).map(key => {
                                    return {
                                        name: key,
                                        size: afterMyGroup[key].length,
                                        sum: _.sumBy(afterMyGroup[key], 'orderMoney'),
                                        refund_size: (afterMyRefundGroup[key] || []).length,
                                        refund_sum: _.sumBy(afterMyRefundGroup[key], 'refundMoney'),
                                        refundArr: (afterMyRefundGroup[key] || []),
                                    }
                                }),
                            },
                        },
                    },
                })
            })
    };
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    changeMessage: {
        name: '',
        phone: ''
    },
    squery: {
        start_time: dateFormat(new Date(), 'yyyy-MM-dd'),
        end_time: dateFormat(new Date(Date.now() + 24 * 3600 * 1000), 'yyyy-MM-dd')
    }, 
    sdata: {
        sdData: {},
        jzhzData: {},
        domainData: {},
        copyData: {},
        myData: {}
    },
    tquery: {
        start_time: moment().set('date', 1).format('YYYY-MM-DD'),
        end_time: dateFormat(new Date(Date.now() + 24 * 3600 * 1000), 'yyyy-MM-dd')
    },
    tdata: {
        devData: {
            copyData: {},
            myData: {},
        },
        afterData: {
            copyData: {},
            myData: {},
        },
    }
}

export default createReducer(initialState,{
    [RECEIVE_BILL_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [CHANGE_MESSAGE]: (state,{key,value}) => {
        return {...state,changeMessage: {...state.changeMessage,[key]: value}}
    },
    [CHANGE_SQUERY]: (state, {key, value}) => {
        return {...state, squery: {...state.squery, [key]: value}}
    },
    [CHANGE_TQUERY]: (state, {key, value}) => {
        return {...state, tquery: {...state.tquery, [key]: value}}
    },
    [S_RECEIVE_LIST]: (state, {data}) => {
        return {...state, sdata: data}
    },
    [T_RECEIVE_LIST]: (state, {data}) => {
        return {...state, tdata: data}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/icenter/reducers/list.js